module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticClass: "logo-wrap"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('img', {
    class: _vm.themeColor,
    attrs: {
      "src": require("../../assets/dice-clear.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "large": "",
      "dark": "",
      "color": _vm.themeColor
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Number'
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("import_export")]), _vm._v("\n            " + _vm._s(_vm.$t('Random Number')) + "\n          ")], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "large": "",
      "dark": "",
      "color": _vm.themeColor
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CustomizeList'
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("view_list")]), _vm._v("\n            " + _vm._s(_vm.$t('Random Custom')) + "\n          ")], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2f68bba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Main.vue
// module id = 437
// module chunks = 1